module.exports = "<div class=\"{{ structure['element_classes'] }}\" [innerHtml]=\"model\"></div>\n"